/**
 * Mouse move parallax effect
 * @requires https://github.com/wagerfield/parallax
 */

import vendorMissing from './vendor-missing'

export default (() => {
  const element = document.querySelectorAll('.parallax')
  if (element.length === 0) return
  if (vendorMissing('parallax', { Parallax: typeof Parallax })) return

  /* eslint-disable no-unused-vars, no-undef */
  for (let i = 0; i < element.length; i++) {
    const parallaxInstance = new Parallax(element[i])
  }
  /* eslint-enable no-unused-vars, no-undef */
})()
